<!--
 * @Description: 推广相关问卷数据分析，多个地方公用修改时需要注意
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__title">
      {{ curItem.title }}
    </div>

    <div>
      <span class="bi-tmpl-detail__right__cmpt__title" style="margin-top: 0">
        请选择图表样式（请至少选择6种图形）
      </span>
      <span
        v-if="curItem.tips"
        style="margin-top: 0"
        class="bi-tmpl-detail__right__cmpt__tips"
      >
        {{ curItem.tips }}
      </span>
    </div>

    <Carousel ref="carouselRef" :itemHeight="1000" :itemWidth="420 + 56">
      <div
        style="width: 100%"
        v-for="(item, index) in group(TYPE_MAPPING, 3)"
        :key="index"
      >
        <BaseCard
          v-for="child in item"
          :key="child.value"
          style="
            width: 420px;
            height: 300px;
            margin-bottom: 18px;
            text-align: center;
          "
          @click="
            () => {
              if (disabled) return;
              onChangeFn(child.value, !checkData?.includes(child.value));
            }
          "
        >
          <div style="height: 240px; overflow: hidden">
            <component :is="cmpName(child.com)" />
          </div>
          <BaseCheckbox
            :model-value="checkData?.includes(child.value)"
            :value="child.value"
            :disabled="disabled"
          >
            {{}}
          </BaseCheckbox>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import PcModulePromotion from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-promotion';

import { BaseCard, BaseCheckbox } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useCheck } from './hooks/use-check';

defineProps(['disabled']);

const TYPE_MAPPING = [
  {
    com: 'pc-module-promotion-1',
    index: 1,
    value: '18'
  },
  {
    com: 'pc-module-promotion-2',
    index: 2,
    value: '2'
  },
  {
    com: 'pc-module-promotion-3',
    index: 3,
    value: '9'
  },
  {
    com: 'pc-module-promotion-4',
    index: 4,
    value: '10'
  },
  {
    com: 'pc-module-promotion-5',
    index: 5,
    value: '14'
  },
  {
    com: 'pc-module-promotion-6',
    index: 6,
    value: '16'
  },
  {
    com: 'pc-module-promotion-7',
    index: 7,
    value: '15'
  },
  {
    com: 'pc-module-promotion-8',
    index: 8,
    value: '20'
  },
  {
    com: 'pc-module-promotion-9',
    index: 9,
    value: '17'
  },
  {
    com: 'pc-module-promotion-10',
    index: 10,
    value: '21'
  },
  {
    com: 'pc-module-promotion-11',
    index: 11,
    value: '22'
  }
];

const { checkData, curItem, onChangeFn, group } = useCheck({
  childKey: '',
  max: 6
});

const cmpName = name => {
  return PcModulePromotion.filter(comp => comp.__name === name)[0];
};
</script>
<style scoped lang="scss"></style>
